import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = /*#__PURE__*/ _createElementVNode("div", { class: "wrapper_header p-2" }, [
    /*#__PURE__*/ _createElementVNode("p", { class: "h5-responsive strong p-0 m-0 fc-white d-inline-block" }, "Deine Gutscheine"),
    /*#__PURE__*/ _createElementVNode("i", {
        class: "icon-brand_close pointerhover",
        style: { "color": "#fff", "float": "right", "padding-right": "6px" }
    })
], -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_coupon_list = _resolveComponent("coupon-list");
    return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["position-relative [ JS_voucherWrapper JS_ContentWrapper ] hidden", _ctx.showMobileStyle ? 'popUpWrapperMobile' : 'popUpWrapper'])
    }, [
        _hoisted_1,
        (_ctx.couponType)
            ? (_openBlock(), _createBlock(_component_coupon_list, {
                key: 0,
                "coupon-type": _ctx.couponType,
                class: "px-2",
                style: { "min-height": "100px" },
                onApplyCoupon: _ctx.applyCoupon,
                "current-selected-coupon-code": _ctx.currentSelectedCouponCode
            }, null, 8, ["coupon-type", "onApplyCoupon", "current-selected-coupon-code"]))
            : _createCommentVNode("", true)
    ], 2));
}
